import { CheckRecord, Report, ReportData } from '@/types'
import { v4 as uuidv4 } from 'uuid'

// 生成报告编号
export function generateReportNumber(): string {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0')

  return `RQ-${year}${month}${day}-${random}`
}

// 创建报告
export function createReport(record: CheckRecord): Report {
  return {
    id: uuidv4(),
    checkRecordId: record.id,
    reportNumber: generateReportNumber(),
    content: '',
    generatedAt: new Date(),
  }
}

// 生成报告数据（用于渲染）
export function generateReportData(record: CheckRecord): ReportData {
  if (!record.summary) {
    throw new Error('检查记录缺少总结数据')
  }

  const checkTypeTextMap: Record<string, string> = {
    liquefied_gas:    '瓶装液化石油气（用户）',
    natural_gas:      '管道天然气（用户）',
    lpg_depot:        '液化石油气储配站',
    lng_gasification: 'LNG 气化站',
    lng_filling:      'LNG 加气站',
    gate_pressure:    '天然气门站/调压站',
  }
  const checkTypeText = checkTypeTextMap[record.checkType] ?? record.checkType

  return {
    reportNumber: generateReportNumber(),
    checkType: checkTypeText,
    inspectedUnit: record.inspectedUnit,
    inspectedAddress: record.inspectedAddress,
    inspector: record.inspector,
    checkDate: formatDate(record.checkDate),
    overview: record.summary.overview,
    majorHazards: record.summary.majorHazards,
    generalHazards: record.summary.generalHazards,
    suggestions: record.summary.suggestions,
    inspectorSignature: record.report?.inspectorSignature,
    unitRepresentativeSignature: record.report?.unitRepresentativeSignature,
    stationManager: record.stationManager,
    lastInspectionDate: record.lastInspectionDate,
  }
}

// 格式化日期
function formatDate(date: Date): string {
  const d = new Date(date)
  return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`
}
